var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { FeatureFlagNames, RoutePath } from 'constants/app.constant';
import { APP_LINK_PAGE_NAME_WITH_ROUTE, EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { checkPathMatch, isEnabledMockService } from 'helpers/app.helper';
import { appActions, appSelectors } from 'redux/ducks/app';
import { CW_UPDATED_TAB_NAMES, PerformancePath } from 'reports/cw/constants/cw.constant';
import useEAQStandaloneCourse from 'reports/cw/hooks/shared/useEAQStandaloneCourse';
import useSafeMedCourse from 'reports/cw/hooks/shared/useSafeMedCourse';
import { ehrPath } from 'reports/ehr/constants/ehr.constant';
import { isCSAppByAppName, isEABAppByAppName } from 'services/app-linking.service';
import { isFeatureEnabled } from 'services/feature-flag.service';
import withRedirectToOutsideApp from 'components/common/with-redirect-to-outside-app/withRedirectToOutsideApp';
import withResizeScreen from 'components/common/with-resize-screen/withResizeScreen';
var CWPageNavigator = function (_a) {
    var windowMode = _a.windowMode, onRedirectToOutsideApp = _a.onRedirectToOutsideApp, currentAppLinkPage = _a.currentAppLinkPage;
    var history = useHistory();
    var dispatch = useDispatch();
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var breadcrumbBackTitle = useSelector(appSelectors.getBreadcrumbBackTitle);
    var isEhrReportingEnabled = useSelector(appSelectors.getIsEhrReportingEnabled);
    var appLinkOutPostBody = useSelector(appSelectors.getAppLinkOutPostBody);
    var isEAQTopicReportFFEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.USPD_EAQ_TOPIC_REPORT_ENABLED);
    var isSafeMedCourse = useSafeMedCourse().isSafeMedCourse;
    var engagementLandingPath = useEAQStandaloneCourse().engagementLandingPath;
    var isCSApp = isCSAppByAppName(breadcrumbBackTitle);
    var isShowEAQTopicReport = !isEABAppByAppName(breadcrumbBackTitle);
    var goToUrlPage = function (url) {
        history.push(url);
    };
    var goToEAQReport = function () { return __awaiter(void 0, void 0, Promise, function () {
        var linkConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isEAQTopicReportFFEnabled) {
                        history.push(PerformancePath.eaqTopicReport.home);
                        return [2 /*return*/];
                    }
                    linkConfig = {
                        appName: EXTERNAL_APP_INFO.APP_LINKING.EAQ.APP_NAME,
                        action: EXTERNAL_APP_INFO.APP_LINKING.EAQ.ACTION.PERFORMANCE_VIEW,
                        isIncludeLinkHash: false
                    };
                    return [4 /*yield*/, onRedirectToOutsideApp(linkConfig, { data: { performanceReportPage: currentAppLinkPage } })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var goToHesiReadinessPage = function () {
        var performanceReportPage = (appLinkOutPostBody || {}).performanceReportPage;
        if (performanceReportPage !== APP_LINK_PAGE_NAME_WITH_ROUTE.PERFORMANCE_HESI_READINESS.name) {
            dispatch(appActions.setIsCWSubNavInEHRPageShow(true));
        }
        history.push(RoutePath.ehr);
    };
    var showEAQTab = isShowEAQTopicReport && !isCSApp && !isEnabledMockService();
    var showHesiTab = isEhrReportingEnabled && !isCSApp && !isSafeMedCourse;
    var isEAQActive = isEAQTopicReportFFEnabled && checkPathMatch([PerformancePath.eaqTopicReport.home]);
    var tabItems = __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        { name: CW_UPDATED_TAB_NAMES.SUMMARY, onClick: function () { return goToUrlPage(RoutePath.home); }, isActive: checkPathMatch([RoutePath.home, RoutePath.cwIns]) },
        { name: CW_UPDATED_TAB_NAMES.STUDENT_GRADEBOOK, onClick: function () { return goToUrlPage(PerformancePath.gradeBook.home); }, isActive: checkPathMatch([PerformancePath.gradeBook.home]) },
        {
            name: CW_UPDATED_TAB_NAMES.ENGAGEMENT,
            onClick: function () { return goToUrlPage(engagementLandingPath); },
            isActive: checkPathMatch(__spreadArray([PerformancePath.engagementSummary], Object.values(PerformancePath.engagement), true))
        }
    ], (isSafeMedCourse
        ? [
            {
                name: CW_UPDATED_TAB_NAMES.ASSESSMENT_SUMMARY,
                onClick: function () { return goToUrlPage(PerformancePath.assessmentSummary); },
                isActive: checkPathMatch([PerformancePath.assessmentSummary, PerformancePath.assessmentDetail, PerformancePath.assessmentStudentDetail])
            }
        ]
        : []), true), (showEAQTab ? [{ name: CW_UPDATED_TAB_NAMES.EAQ, onClick: goToEAQReport, isActive: isEAQActive }] : []), true), [
        { name: CW_UPDATED_TAB_NAMES.ASSIGNMENTS, onClick: function () { return goToUrlPage(PerformancePath.assignmentSummary); }, isActive: checkPathMatch([PerformancePath.assignmentSummary]) }
    ], false), (showHesiTab ? [{ name: CW_UPDATED_TAB_NAMES.HESI_SPECIALTY_EXAM_READINESS, onClick: goToHesiReadinessPage, isActive: checkPathMatch(Object.values(ehrPath)) }] : []), true);
    var renderTabItem = function (_a) {
        var name = _a.name, onClick = _a.onClick, isActive = _a.isActive;
        return (<button key={name} type="button" tabIndex={0} className={classNames('u-els-anchorize c-els-tab-group__item', { 'c-els-tab-group__item--active': isActive })} aria-current={isActive ? 'page' : undefined} onClick={onClick}>
      <span className="c-els-tab-group__text">{name}</span>
    </button>);
    };
    if (windowMode.mobile) {
        return null;
    }
    return (<nav className="c-cw-page-navigator" aria-label="Performance & Grades sections">
      <div className="u-max-width-1400 c-cw-report-content c-els-tab-group c-cw-page-navigator__menu">{tabItems.map(renderTabItem)}</div>
      <div className="c-els-divider c-els-divider--1o2"/>
    </nav>);
};
export { CWPageNavigator as CWPageNavigatorBase };
export default withResizeScreen(withRedirectToOutsideApp(CWPageNavigator));
